<template>
  <v-flex xs12 sm8 md6 lg3>
    <v-card
      class="px-3 pt-3 pt-sm-6 px-sm-6 language-switch-card"
      :class="{ 'elevation-12': $vuetify.breakpoint.smAndUp }"
      flat
    >
      <v-img :src="logo_src" max-width="300" :aspect-ratio="5.454545"></v-img>
      <v-window v-model="selectedWindow">
        <v-window-item value="selectuser">
          <select-usernames
            :usernames="loggedInUsernames"
            @select-user="selectUser"
            @update:usernames="loggedInUsernames = $event"
            @update:window="selectedWindow = $event"
          ></select-usernames>
        </v-window-item>
        <v-window-item value="login">
          <login-section
            ref="loginSection"
            :selected-user="selectedUser"
            :usernames="loggedInUsernames"
            :force2fa-login="force2faLogin"
            @update:usernames="loggedInUsernames = $event"
            @update:window="selectedWindow = $event"
          ></login-section>
        </v-window-item>
      </v-window>
      <language-switch></language-switch>
    </v-card>
  </v-flex>
</template>

<script>
import LoginSection from "./LoginSection";
import SelectUsernames from "./SelectUsernames";
import LanguageSwitch from "@/components/globals/LanguageSwitch";

export default {
  name: "Login",
  title: "login",
  components: {
    SelectUsernames,
    LoginSection,
    LanguageSwitch,
  },
  data: () => ({
    logo_src: require("@/assets/SmartCONNECT_logo.svg"),
    selectedWindow: null,
    selectedUser: null,
    force2faLogin: false,
    loggedInUsernames: JSON.parse(localStorage.getItem("usernames")) || [],
  }),
  computed: {
    loggedInUsernamesExist() {
      return this.loggedInUsernames.length > 0;
    },
  },
  watch: {
    selectedWindow(val) {
      setTimeout(() => {
        if (val === "login") {
          if (!this.selectedUser) {
            this.$refs.loginSection.$refs.loginForm.$refs.usernameInput.$refs.input.focus();
          } else {
            this.$refs.loginSection.$refs.loginForm.$refs.passwordInput.$refs.input.focus();
          }
        }
        if (val === "2fa") {
          this.$refs.twoFactorAuthentication.$refs.verificationCode.$refs.input.focus();
        }
      }, 300);
      if (val === "selectuser") {
        this.selectedUser = null;
      }
    },
    loggedInUsernames(names) {
      localStorage.setItem("usernames", JSON.stringify(names));
      if (names.length === 0) {
        this.selectedWindow = "login";
      }
    },
  },
  created() {
    if (this.$route.params.login2fa) {
      this.force2faLogin = true;
    }
  },
  mounted() {
    if (this.loggedInUsernamesExist) {
      this.selectedWindow = "selectuser";
    } else {
      this.selectedWindow = "login";
    }
  },
  methods: {
    selectUser(selectedUser) {
      this.selectedUser = selectedUser;
      this.selectedWindow = "login";
    },
  },
};
</script>
